// Copyright (c) 2016 Deere & Company

import './file-csv-upload.scss';
import {
    FormattedMessage,
    injectIntl,
    intlShape
} from 'react-intl';
import React, {Component, PropTypes} from 'react';
import {
    createErrorObject,
    errorAlertBar
} from '../../services/alert-bar';
import Dropzone from 'dropzone';
import DropzoneComponent from 'react-dropzone-component';
import Papa from 'papaparse';
import {getFileUploadCsvErrorMessage} from '../../services/file-service';

Dropzone.confirm = (question, accepted) => accepted();

let dropzoneComponent;

const init = dropzone => {

    dropzoneComponent = dropzone;

};

function handleFileUploadError(file, errorMessage) {

    errorAlertBar(createErrorObject(this.intl.formatMessage({
        id: getFileUploadCsvErrorMessage(errorMessage)
    })));

}

class FileCsvUpload extends Component {

    constructor(props) {

        super(props);
        this.state = {
            djsConfig: {
                autoProcessQueue: false,
                disablePreviews: true,
                maxFilesize: 1,
                ...this.props.djsConfig
            }

        };

    }

    render() {

        const handleFileAdded = file => {

            /* eslint-disable complexity, max-depth */

            if (file.size < 1000000) {

                Papa.parse(file, {
                    complete: results => {

                        if (results.errors.length || results.data.length === 0) {

                            if (results.errors.length === 0) {

                                const errorObject = {
                                    message: 'No data found.  Please check your file'
                                };

                                errorAlertBar(errorObject);

                            } else {

                                let i;

                                for (i = 0; i < results.errors.length; i += 1) {

                                    const errorObject = {
                                        message: `Error ${results.errors[i].message} on row ${results.errors[i].row}`
                                    };

                                    errorAlertBar(errorObject);

                                }

                            }

                        } else {

                            this.props.handleFileAdded(results.data);

                        }

                    },
                    header: true,
                    skipEmptyLines: true
                });

            }

            /* eslint-enable complexity, max-depth */

            dropzoneComponent.removeFile(file);

        };

        const componentConfig = {
            postUrl: 'no-url'
        };

        const eventHandlers = {
            addedfile: handleFileAdded,
            error: this.props::handleFileUploadError,
            init
        };

        return (

            <div className='file-upload'>
                <DropzoneComponent
                    config={componentConfig}
                    djsConfig={this.state.djsConfig}
                    eventHandlers={eventHandlers}
                >
                    <span className='required-label'>
                        <div className='dz-message'>
                            <FormattedMessage id={this.props.displayMessage || 'FILE_UPLOAD_MESSAGE_CSV'}/>
                        </div>
                    </span>
                </DropzoneComponent>
            </div>

        );

    }

}

FileCsvUpload.displayName = 'FileUpload';
FileCsvUpload.propTypes = {
    displayMessage: PropTypes.string,
    djsConfig: PropTypes.object,
    handleFileAdded: PropTypes.func.isRequired,
    intl: intlShape
};

export default injectIntl(FileCsvUpload);



// WEBPACK FOOTER //
// ./src/shared/components/file-csv-upload/index.js